export default __webpack_public_path__ + "navigation-examples-electronic-horizon-960-d7dbc489464eac196230e1b5f8c9d1ac.webp";